const STORAGE_KEY = 'seminar-filter-restore';
const MAX_AGE_MS = 10 * 60 * 1000;

export const useSeminarRestore = () => {
  const saveSeminarRestore = (search: string): void => {
    if (IS_SSR) {
      return;
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ search, ts: Date.now() }));
    } catch (e) {
      console.error('[seminar-filter-restore] could not save', e);
    }
  };

  const consumeSeminarRestore = (): string | null => {
    if (IS_SSR) {
      return null;
    }
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === null) {
        return null;
      }
      localStorage.removeItem(STORAGE_KEY);
      const { search, ts } = JSON.parse(stored);
      return Date.now() - ts <= MAX_AGE_MS ? search : null;
    } catch (e) {
      console.error('[seminar-filter-restore] could not read', e);
      return null;
    }
  };

  return { saveSeminarRestore, consumeSeminarRestore };
};
